import * as api from '../services/oldApiService';

export const strongPassword = new RegExp(
  '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})'
);

export const isUsedEmail = async (email) => {
  if (email !== '') {
    const { status_code: statusCode, data } = await api.emailValidation({
      email
    });
    if (statusCode === api.status.SUCCESS) {
      return !data.email_used;
    } else {
      return true;
    }
  } else {
    return true;
  }
};
